import {useEffect, useState} from 'react';
import {ButtonCopyToClipboard} from '../ButtonCopyToClipboard';
import './Banner.css';
import fontoptions from './fontoptions.json';
const figlet = require('figlet');
export const Banner = () => {
	const [result, setResult] = useState<string>('');
	const [font, setFont] = useState<string>('Standard');
	const [source, setSource] = useState<string>('My cool application');
	const [includeColor, setIncludeColor] = useState<boolean>(false);
	const [includeVersions, setIncludeVersions] = useState<boolean>(false);

	const ansiColorBegin = '${AnsiColor.BLUE}\n';
	const ansiColorEnd = '\n${AnsiStyle.NORMAL}\n';
	const fontOptions = fontoptions.map((i) => {
		const treated = i.split('.')[0];
		return (
			<option key={i} value={treated}>
				{treated}
			</option>
		);
	});
	const versionsContent = `
Version number of your application declared in MANIFEST.MF: \${application.version}
Version number of your application declared in MANIFEST.MF formatted: \${application.formatted-version}
Spring Boot version: \${spring-boot.version}
Spring Boot version formatted: \${spring-boot.formatted-version}
The title of your application, as declared in MANIFEST.MF: \${application.title}
`;
	useEffect(() => {
		figlet.text(
			source,
			{
				font: font,
				horizontalLayout: 'default',
				verticalLayout: 'default',
				width: 8000,
				whitespaceBreak: true,
			},
			function (error: Error, result: string) {
				// console.log('result: ' + result);

				let complete = '';
				if (includeColor) complete += ansiColorBegin;
				complete += result;
				if (includeColor) complete += ansiColorEnd;
				if (includeVersions) complete += versionsContent;
				setResult(complete);
			}
		);
	}, [source, includeColor, includeVersions, font]);

	return (
		<div className='panel'>
			<div className='custom-header1'>
				<h2>Spring Boot Banner Generator</h2>
			</div>
			<div className='banner-input' key='banner-input-div'>
				<input
					key='banner-input'
					autoFocus={true}
					value={source}
					onChange={(e) => setSource(e.target.value)}
				/>
			</div>
			<div className='banner-result' key='banner-result'>
				<textarea readOnly={true} value={result}>
					{result}
				</textarea>
			</div>
			<div className='banner-options' key='banner-options'>
				<div className='banner-option-font'>
					<select
						onChange={(e) => {
							setFont(e.target.value);
						}}
						name='fontoptions'
						value={font}
					>
						{fontOptions}
					</select>
				</div>
				<div onChange={() => setIncludeVersions(includeVersions === false)}>
					<label>
						<input
							onChange={() => {}}
							checked={includeVersions}
							type={'checkbox'}
						/>
						Include versions
					</label>
				</div>
				<div onChange={() => setIncludeColor(includeColor === false)}>
					<label>
						<input
							onChange={() => {}}
							checked={includeColor}
							type={'checkbox'}
						/>
						Include color
					</label>
				</div>
				<div className='banner-copy'>
					<ButtonCopyToClipboard key={'banner-result'} text={result} />
				</div>
			</div>
			<div>
				<a href='https://docs.spring.io/spring-boot/docs/2.1.6.RELEASE/reference/html/boot-features-spring-application.html#boot-features-banner'>
					Spring Documentation on Banners
				</a>
			</div>
		</div>
	);
};
